@if (fields.length > 0) {
  <form [formGroup]="form" class="report-filter-bar no-print" data-testid="report-filter-bar">
    <formly-form [form]="form" [fields]="fields" [model]="model" />
  </form>
}
